module.exports = __webpack_public_path__ + "img/escola-parochial.02038b6d.jpg";